import type { HTMLAttributes, ReactNode } from 'react';

import { cn } from '@/utils/cls';

interface CardProps extends HTMLAttributes<HTMLDivElement> {
  padded?: boolean;
}

/** Surface container — every grouped chunk of UI lives in one. */
export function Card({ className, padded = true, ...rest }: CardProps) {
  return <div className={cn('card', padded && 'p-5', className)} {...rest} />;
}

interface SectionHeaderProps {
  title: ReactNode;
  description?: ReactNode;
  actions?: ReactNode;
  className?: string;
}

export function SectionHeader({ title, description, actions, className }: SectionHeaderProps) {
  return (
    <div className={cn('flex items-start justify-between gap-4 mb-4', className)}>
      <div className="min-w-0">
        <h2 className="text-lg font-semibold text-ink">{title}</h2>
        {description && (
          <p className="text-sm text-ink-soft mt-0.5">{description}</p>
        )}
      </div>
      {actions && <div className="flex-shrink-0 flex gap-2">{actions}</div>}
    </div>
  );
}
